import { MenuItem } from "../../Types/Layout/SidebarType";

export const LockerMenuList: MenuItem[] = [
  {
    title: "General",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "home",
        type: "link",
        lanClass: "lan-3",
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
      },
    ],
  },
  {
    title: "Applications",
    lanClass: "lan-8",
    Items: [
      {
        title: "Ticket Booking",
        id: 3,
        icon: "project",
        type: "sub",
        active: false,
        children: [
          { path: `${process.env.PUBLIC_URL}/locker/locker_assign`, type: "link", title: "Locker Assign" },
          { path: `${process.env.PUBLIC_URL}/locker/all_locker_assign`, type: "link", title: "All Locker Assign" },
        ],
      },
    ],
  },
];
